import {
    searchDataAuth,
    addDataAuth,
    deleteDataAuth,
    updateDataAuth,
    UpdateAllDataAuth,
    UpdateAreaDataAuth,
    QueryAreaDataAuth,
    QueryAllDataAuth
} from '@/request/dataAuth';
export default {
    namespace: true,
    state: {
        selectionsAuthList: {}
    },
    mutations: {
        SET_SELECTIONS_AUTH_LIST(state, selectionsAuthList) {
            state.selectionsAuthList = selectionsAuthList;
        }
    },
    actions: {
        SearchDataAtuhList: async ({ commit }, payload) => {
            let res = await searchDataAuth(payload);
            return res;
        },

        AddDataAuth: async ({}, payload) => {
            let res = await addDataAuth(payload);
            return res;
        },

        DeleteDataAuth: async ({}, payload) => {
            let res = await deleteDataAuth(payload);
            return res;
        },

        UpdateDataAuth: async ({}, payload) => {
            let res = await updateDataAuth(payload);
            return res;
        },

        UPDATE_ALL_DATA_AUTH: async ({ commit }, payload) => {
            let res = await UpdateAllDataAuth(payload);
            return res;
        },
        UPDATE_AREA_DATA_AUTH: async ({ commit }, payload) => {
            let res = await UpdateAreaDataAuth(payload);
            return res;
        },

        QUERY_ALL_DATA_AUTH: async ({ commit }, payload) => {
            let res = await QueryAllDataAuth(payload);
            return res;
        },

        QUERY_AREA_DATA_AUTH: async ({ commit }, payload) => {
            let res = await QueryAreaDataAuth(payload);
            return res;
        }
    }
};
